import { inject, Provider } from '@angular/core';
import { Routes } from '@angular/router';
import { environment } from '../environments/environment';
import { SettingsPhoneComponent } from './main/settings/tabs/phone/phone.component';
import { VoicemailDemoChatService } from './main/voicemail/services/voicemail-demo-chat.service';
import { VoicemailPortalSessionService } from './main/voicemail/services/voicemail-portal-session.service';
import {
  VOICEMAIL_PHONE_TAB,
  VOICEMAIL_SAMPLE_CHAT,
  VOICEMAIL_UNREAD_COUNT,
} from './voicemail.tokens';

/**
 * Portal wiring only. The gateway itself now comes from apiServicesProviders, so which
 * implementation is used follows environment.useMock like every other service -- previously the demo
 * double was provided unconditionally and shipped in production builds.
 */
export const VOICEMAIL_PROVIDERS: Provider[] = [
  {
    provide: VOICEMAIL_UNREAD_COUNT,
    useFactory: () => inject(VoicemailPortalSessionService).unreadCount,
  },
  { provide: VOICEMAIL_PHONE_TAB, useValue: SettingsPhoneComponent },
  // Simulated chat, for mock builds only. Chat and the calls page inject this optionally and fall
  // back to the live chat service, so leaving it unprovided in real builds disables the simulation
  // without touching either of them.
  ...(environment.useMock
    ? [{ provide: VOICEMAIL_SAMPLE_CHAT, useClass: VoicemailDemoChatService }]
    : []),
];

export const VOICEMAIL_ROUTES: Routes = [
  {
    path: 'calls',
    data: { breadcrumb: 'Calls & voicemails' },
    loadComponent: () =>
      import('./main/voicemail/calls-page/calls-page.component').then(
        m => m.CallsPageComponent
      ),
  },
];
